import { DataSource, Layout } from "@mcleod/components";
import { FtlStop } from "../FtlStop";

export abstract class AutogenLayoutFtlQuoteStopDetails extends Layout {
    layoutStopTable: FtlStop;
    sourceQuoteStops: DataSource;
}
